(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["koia-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-atc')) {
    customElements.define(
      'sticky-atc',
      class StickyAtc extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-sticky-atc-button]');
          this.label = this.querySelector('[data-sticky-atc-label]');
          this.price = this.querySelector('[data-sticky-atc-price]');
          this.flavorSelect = this.querySelector('[data-sticky-atc-flavor]');
          this.planSelect = this.querySelector('[data-sticky-atc-plan]');
          this.planWrap = this.querySelector('[data-sticky-atc-plan-wrap]');
          this.target = document.getElementById(this.dataset.target);
          this.form = document.getElementById(this.dataset.formId);
          this.onetimePriceFallback = this.price ? this.price.textContent.trim() : '';
          this.syncingFromWidget = false;
          this.syncingFromSticky = false;
          this.lastSellingPlanId = '';
          this.trackedVariantId = this.dataset.variantId || '';

          if (!this.button || !this.target) return;

          this.onClick = this.onClick.bind(this);
          this.onFlavorChange = this.onFlavorChange.bind(this);
          this.onPlanChange = this.onPlanChange.bind(this);
          this.syncPurchaseOption = this.syncPurchaseOption.bind(this);
          this.onPageTransitioned = this.onPageTransitioned.bind(this);

          this.button.addEventListener('click', this.onClick);
          if (this.flavorSelect) this.flavorSelect.addEventListener('change', this.onFlavorChange);
          if (this.planSelect) this.planSelect.addEventListener('change', this.onPlanChange);

          this.observer = new IntersectionObserver(
            ([entry]) => {
              const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle('is-visible', scrolledPast);
              this.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
            },
            { threshold: 0 }
          );
          this.observer.observe(this.target);

          this.syncFromTarget();
          this.mutationObserver = new MutationObserver(() => this.syncFromTarget());
          this.mutationObserver.observe(this.target, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class'],
            subtree: true,
            childList: true,
          });

          this.bindPurchaseOptionSync();

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              const html = event?.data?.html;
              if (html && this.price) {
                const updatedPrice = html.querySelector(`#price-${event.data.sectionId}`);
                if (updatedPrice) this.onetimePriceFallback = updatedPrice.textContent.trim();
              }
              this.syncFromTarget();
              this.syncPurchaseOption();
            });
          }

          document.addEventListener('pageTransitioned', this.onPageTransitioned);
        }

        onPageTransitioned() {
          this.lastSellingPlanId = '';
          this.observedWidget = null;
          this.refreshContext();
          this.ensureWidgetObserver();
          this.syncPurchaseOption();
        }

        disconnectedCallback() {
          if (this.button) this.button.removeEventListener('click', this.onClick);
          if (this.flavorSelect) this.flavorSelect.removeEventListener('change', this.onFlavorChange);
          if (this.planSelect) this.planSelect.removeEventListener('change', this.onPlanChange);
          if (this.observer) this.observer.disconnect();
          if (this.mutationObserver) this.mutationObserver.disconnect();
          if (this.sellingPlanObserver) this.sellingPlanObserver.disconnect();
          if (this.widgetObserver) this.widgetObserver.disconnect();
          this.observedWidget = null;
          if (this.purchasePollId) clearInterval(this.purchasePollId);
          if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
          document.removeEventListener('pageTransitioned', this.onPageTransitioned);
          if (this.form) this.form.removeEventListener('change', this.syncPurchaseOption);
        }

        onClick() {
          if (!this.target || this.target.disabled || this.target.getAttribute('aria-disabled') === 'true') {
            return;
          }
          // Ensure the form matches the sticky plan selection before submit.
          if (this.planSelect && !this.planWrap?.hidden) {
            this.applyPurchaseOption(this.planSelect.value);
          }
          this.target.click();
        }

        onFlavorChange() {
          const url = this.flavorSelect?.value;
          if (!url) return;

          const link = document.querySelector(`a.allow-barba-transition[href="${url}"]`);
          if (link) {
            link.click();
            return;
          }

          window.location.href = url;
        }

        onPlanChange() {
          if (this.syncingFromWidget || !this.planSelect) return;
          this.syncingFromSticky = true;
          this.applyPurchaseOption(this.planSelect.value);
          this.updatePriceFromSelection(this.planSelect.value);
          // Recharge updates its DOM asynchronously after the option click.
          window.setTimeout(() => {
            this.updatePriceFromSelection(this.planSelect.value);
            this.syncingFromSticky = false;
          }, 200);
        }

        getSellingPlanInput() {
          if (!this.form) return null;
          let input = this.form.querySelector('input[name="selling_plan"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'selling_plan';
            this.form.appendChild(input);
          }
          return input;
        }

        getActiveSellingPlanId() {
          const widget = document.querySelector('recharge-subscription-widget');
          const checkedPlan = widget ? this.queryDeep(widget, 'input[name="rc_plan"]:checked') : null;
          if (checkedPlan?.value) return String(checkedPlan.value);

          const existing = this.form?.querySelector('input[name="selling_plan"]')?.value;
          if (existing) return String(existing);

          const variantId = this.getVariantId();
          // Prefer a plan id that belongs to the current variant's price map.
          const sellingPlans =
            window.SubscriptionWidgetConfig?.formattedPrices?.[variantId]?.sellingPlans;
          if (sellingPlans) {
            if (this.lastSellingPlanId && sellingPlans[this.lastSellingPlanId]) {
              return String(this.lastSellingPlanId);
            }
            const firstId = Object.keys(sellingPlans)[0];
            if (firstId) return String(firstId);
          }

          if (this.lastSellingPlanId) return this.lastSellingPlanId;

          const plans = window.SubscriptionWidgetConfig?.shopifyPlans;
          if (plans?.[0]?.id) return String(plans[0].id);

          return null;
        }

        applyPurchaseOption(value) {
          const input = this.getSellingPlanInput();
          if (!input) return;

          if (value === 'onetime') {
            if (input.value) this.lastSellingPlanId = input.value;
            input.value = '';
          } else {
            const planId = this.getActiveSellingPlanId();
            if (planId) {
              this.lastSellingPlanId = planId;
              input.value = planId;
            }
          }

          // Keep Recharge UI in sync when possible.
          this.selectRechargeOption(value);
        }

        bindPurchaseOptionSync() {
          this.refreshContext();

          if (this.form) {
            this.form.addEventListener('change', this.syncPurchaseOption);
            this.sellingPlanObserver = new MutationObserver(() => this.syncPurchaseOption());
            this.sellingPlanObserver.observe(this.form, {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['value', 'checked'],
            });
          }

          this.ensureWidgetObserver();

          let attempts = 0;
          this.purchasePollId = setInterval(() => {
            attempts += 1;
            this.ensureWidgetObserver();
            this.syncPurchaseOption();
            if (attempts >= 40) clearInterval(this.purchasePollId);
          }, 250);

          this.syncPurchaseOption();
        }

        ensureWidgetObserver() {
          const widget = document.querySelector('recharge-subscription-widget');
          if (!widget || this.observedWidget === widget) return;

          if (this.widgetObserver) this.widgetObserver.disconnect();
          this.observedWidget = widget;
          this.widgetObserver = new MutationObserver(() => {
            if (this.syncingFromSticky) return;
            this.syncPurchaseOption();
          });
          this.widgetObserver.observe(widget, { attributes: true, childList: true, subtree: true });
          if (widget.shadowRoot) {
            this.widgetObserver.observe(widget.shadowRoot, {
              attributes: true,
              childList: true,
              subtree: true,
            });
          }
        }

        refreshContext() {
          this.target = document.getElementById(this.dataset.target) || this.target;
          this.form = document.getElementById(this.dataset.formId) || this.form;

          const variantId = this.getVariantId();
          if (variantId && this.trackedVariantId && this.trackedVariantId !== variantId) {
            this.lastSellingPlanId = '';
            const onetimeFromWidget = this.readOptionPrice('onetime');
            if (onetimeFromWidget) this.onetimePriceFallback = onetimeFromWidget;
          }
          if (variantId) this.trackedVariantId = variantId;
        }

        queryDeep(root, selector) {
          if (!root) return null;

          if (root.querySelector) {
            const direct = root.querySelector(selector);
            if (direct) return direct;
          }

          // Important: pierce the host's own shadow root (Recharge widget).
          if (root.shadowRoot) {
            const inOwnShadow = this.queryDeep(root.shadowRoot, selector);
            if (inOwnShadow) return inOwnShadow;
          }

          const hosts = root.querySelectorAll ? root.querySelectorAll('*') : [];
          for (const el of hosts) {
            if (!el.shadowRoot) continue;
            const found = this.queryDeep(el.shadowRoot, selector);
            if (found) return found;
          }
          return null;
        }

        getVariantId() {
          return this.form?.querySelector('input[name="id"]')?.value || this.dataset.variantId;
        }

        getPlanPrice(planId) {
          if (!planId) return null;
          const variantId = this.getVariantId();
          const plan =
            window.SubscriptionWidgetConfig?.formattedPrices?.[variantId]?.sellingPlans?.[planId];
          return plan?.price || null;
        }

        getFormattedPrices() {
          const variantId = this.getVariantId();
          const prices = window.SubscriptionWidgetConfig?.formattedPrices?.[variantId];
          if (!prices) return null;

          const planId =
            this.form?.querySelector('input[name="selling_plan"]')?.value || this.lastSellingPlanId;
          const planPrice = this.getPlanPrice(planId);

          return {
            onetime: prices.unit || this.onetimePriceFallback,
            subscription: planPrice || prices.discounted || prices.unit || this.onetimePriceFallback,
          };
        }

        buildPlanOptions() {
          if (!this.planSelect || !this.planWrap) return;

          const widget = document.querySelector('recharge-subscription-widget');
          if (!widget) {
            this.planWrap.hidden = true;
            return;
          }

          const onetimeLabel = this.dataset.onetimeLabel || 'One-time';
          const subscribeLabel = this.dataset.subscribeLabel || 'Subscribe & save';
          const current = this.readRechargeSelection() || this.planSelect.value || 'subscription';

          this.planSelect.innerHTML = '';

          const onetimeOption = document.createElement('option');
          onetimeOption.value = 'onetime';
          onetimeOption.textContent = onetimeLabel;
          this.planSelect.appendChild(onetimeOption);

          const subOption = document.createElement('option');
          subOption.value = 'subscription';
          subOption.textContent = subscribeLabel;
          this.planSelect.appendChild(subOption);

          this.planSelect.value = current === 'onetime' ? 'onetime' : 'subscription';
          this.planWrap.hidden = false;
        }

        readRechargeSelection() {
          const sellingPlanInput = this.form?.querySelector('input[name="selling_plan"]');
          const formPlan = sellingPlanInput?.value;
          if (formPlan) {
            this.lastSellingPlanId = formPlan;
            return 'subscription';
          }

          const widget = document.querySelector('recharge-subscription-widget');
          if (widget) {
            // Recharge often marks selection via rc-selected / part, not input:checked.
            const selected =
              this.queryDeep(widget, '[rc-selected]') ||
              this.queryDeep(widget, '[part*="rc-purchase-option__selected"]') ||
              this.queryDeep(widget, '.rc-purchase-option__selected');

            if (selected) {
              const isOnetime =
                selected.classList.contains('rc-selection__onetime') ||
                selected.classList.contains('rc-purchase-option__onetime') ||
                selected.getAttribute('part')?.includes('onetime');
              if (isOnetime) return 'onetime';

              if (sellingPlanInput) {
                const planId = this.getActiveSellingPlanId();
                if (planId) {
                  sellingPlanInput.value = planId;
                  this.lastSellingPlanId = planId;
                }
              }
              return 'subscription';
            }

            const checked = this.queryDeep(widget, '.rc-purchase-option__input:checked');
            if (checked?.value === 'subscription' || checked?.value === 'onetime') {
              if (checked.value === 'subscription' && sellingPlanInput) {
                const planId = this.getActiveSellingPlanId();
                if (planId) {
                  sellingPlanInput.value = planId;
                  this.lastSellingPlanId = planId;
                }
              }
              return checked.value;
            }
          }

          if (sellingPlanInput) return 'onetime';
          return null;
        }

        selectRechargeOption(value) {
          const widget = document.querySelector('recharge-subscription-widget');
          if (!widget) return;

          const input = this.queryDeep(widget, `.rc-purchase-option__input[value="${value}"]`);
          if (!input) return;

          input.checked = true;
          input.click();
          input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
          input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
        }

        extractPriceText(priceEl) {
          if (!priceEl) return null;
          const text = priceEl.textContent || '';
          return text.match(/\$[\d,.]+/)?.[0] || text.trim() || null;
        }

        readOptionPrice(purchaseOption) {
          const widget = document.querySelector('recharge-subscription-widget');
          if (!widget) return null;

          let option;
          if (purchaseOption === 'subscription') {
            option =
              this.queryDeep(widget, '.rc-purchase-option__subscription') ||
              this.queryDeep(widget, '[part*="rc-purchase-option__subscription"]');
          } else {
            option =
              this.queryDeep(widget, '.rc-selection__onetime') ||
              this.queryDeep(widget, '.rc-purchase-option__onetime') ||
              this.queryDeep(widget, '[part*="rc-purchase-option__onetime"]');
          }
          if (!option) return null;

          if (purchaseOption === 'subscription') {
            const discounted =
              option.querySelector('[part="rc-purchase-option__discounted-price"]') ||
              option.querySelector('.rc-purchase-option__discounted-price') ||
              option.querySelector('.rc-price:not(.strike-through)');
            const discountedPrice = this.extractPriceText(discounted);
            if (discountedPrice) return discountedPrice;
          }

          const priceEl =
            option.querySelector('[part="rc-purchase-option__price"]') ||
            option.querySelector('.rc-purchase-option__price') ||
            option.querySelector('.rc-price:not(.strike-through)');

          return this.extractPriceText(priceEl);
        }

        updatePriceFromSelection(value) {
          if (!this.price) return;

          // Always prefer live Recharge option prices. This stays correct after
          // flavor/product transitions when SubscriptionWidgetConfig can be stale.
          const widgetPrice = this.readOptionPrice(value);
          if (widgetPrice) {
            this.price.textContent = widgetPrice;
            if (value === 'onetime') this.onetimePriceFallback = widgetPrice;
            return;
          }

          const prices = this.getFormattedPrices();
          if (value === 'subscription') {
            const planId =
              this.form?.querySelector('input[name="selling_plan"]')?.value || this.lastSellingPlanId;
            this.price.textContent =
              this.getPlanPrice(planId) || prices?.subscription || this.onetimePriceFallback;
          } else {
            this.price.textContent = prices?.onetime || this.onetimePriceFallback;
          }
        }

        syncPurchaseOption() {
          if (this.syncingFromSticky) return;

          this.refreshContext();
          this.buildPlanOptions();

          const selection = this.readRechargeSelection() || 'onetime';
          this.syncingFromWidget = true;
          if (this.planSelect && !this.planWrap?.hidden) {
            this.planSelect.value = selection;
          }
          this.syncingFromWidget = false;

          this.updatePriceFromSelection(selection);
        }

        syncFromTarget() {
          if (!this.target || !this.button) return;

          const disabled =
            this.target.disabled || this.target.getAttribute('aria-disabled') === 'true';
          this.button.disabled = disabled;

          const targetLabel = this.target.querySelector('span:not(.visually-hidden)');
          if (this.label && targetLabel) {
            const text = targetLabel.textContent.trim();
            if (text) this.label.textContent = text;
          } else if (this.label) {
            this.label.textContent = disabled
              ? this.dataset.soldOutLabel
              : this.dataset.addLabel;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
